import {useParams} from 'react-router-dom'
import {appsAPI} from '../../../../services/AppsService'
import {useIntl} from 'react-intl'
import {ITrunkModel} from '../../../../types/apps/common/TrunkModel'

const IgnoreLines = () => {
  const intl = useIntl()
  const {appId} = useParams()
  const {data: app} = appsAPI.useFetchAppByIdQuery(appId!)
  return (
    <>
      <div className='row mb-5'>
        <label className='col-lg-4 fw-bolder text-gray-600 text-uppercase small'>
          {intl.formatMessage({id: 'APPS.SETTINGS.IGNORE'})}
        </label>

        <div className='col-lg-8'>
          {app?.settings.ignore_trunks &&
            app?.settings.ignore_trunks.map((ignoreTrunk: ITrunkModel) => (
              <span className='badge badge-secondary me-3 mb-3' key={ignoreTrunk.trunk}>
                {ignoreTrunk.trunk}
              </span>
            ))}
        </div>
      </div>
    </>
  )
}

export {IgnoreLines}
